@if (showBanner && promoSignPostingContent()?.text) {
    <div class="promo-signposting">
        <div [vnDynamicHtml]="promoSignPostingContent()?.text"></div>
        <div class="close-icon" (click)="onCloseBanner()"><span class="ui-icon ui-icon-size-md ui-close theme-ex"></span></div>
    </div>
}
